module.exports = __webpack_public_path__ + "media/assets/stores/barnes-and-noble-74fdd1154e990fdcb5cb3c36d8d3586c.jpg";